// extracted by mini-css-extract-plugin
export var isPrimary = "NavList-module--isPrimary--b3b14";
export var isReverse = "NavList-module--isReverse--377f8";
export var item = "NavList-module--item--7be01";
export var link = "NavList-module--link--f3044";
export var linkActive = "NavList-module--linkActive--584e3";
export var navlist = "NavList-module--navlist--f1085";
export var showActive = "NavList-module--showActive--a9226";